import "./index.scss";

export const BrandAlsoAcceptedAt = ({ acceptedAt }) => (
  <div className="brand-also-accepted-at" data-testid="brand-also-accepted-at">
    <h3>Also Accepted At</h3>
    <div className="accepted-brand-list">
      {acceptedAt.map(({ path, iconUrl, name }) => (
        <a className="accepted-brand" href={path} key={path}>
          <img
            width={70}
            height={70}
            alt="accepted at brand icon"
            src={iconUrl}
            importance="low"
            decoding="async"
            loading="lazy"
          />
          <p>{name}</p>
        </a>
      ))}
    </div>
  </div>
);
